/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_FunnelInputs */

const en_admin_nav_funnel = /** @type {(inputs: Admin_Nav_FunnelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funnel`)
};

/**
* | output |
* | --- |
* | "Funnel" |
*
* @param {Admin_Nav_FunnelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_funnel = /** @type {((inputs?: Admin_Nav_FunnelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_FunnelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_funnel(inputs)
});
export { admin_nav_funnel as "admin.nav.funnel" }